import React, { Component } from 'react'
import PropTypes from 'prop-types'
import jwtDecode from 'jwt-decode'
import qs from 'query-string'
import { withRouter } from 'react-router'
import { compose } from 'redux'
import { connect } from 'react-redux'

import { signIn } from '../../store/AppState/actions'
import {
  isOutsideIframe,
  setToken,
  isLoopedLogin,
  logOutAndRedirect,
} from '../../utils/auth'

class OAuthCallback extends Component {
  componentDidMount = () => {
    const parsedData = qs.parse(window.location.hash)
    if (parsedData) {
      const { access_token: token } = parsedData
      const { history } = this.props

      if (token && !isLoopedLogin()) {
        this.login(token)

        if (isOutsideIframe()) {
          setTimeout(() => {
            history.push('/')
          }, 200)
        }
      }
    }
  }

  login = (token) => {
    // eslint-disable-next-line
    const { signIn } = this.props
    const { exp, sub, email, name, app_role } = jwtDecode(token)

    const user = {
      email,
      id: sub,
      fullName: name,
      orgName: app_role[1] ?? '',
    }

    signIn(user)
    setToken(token, exp)
  }

  render() {
    return isLoopedLogin() ? (
      <section className="looped-screen">
        <p>Something went wrong, log out and sign in again</p>
        <div>
          <button
            className="btn -primary"
            onClick={logOutAndRedirect}
          >
            Log Out
          </button>
        </div>
      </section>
    ) : (
      <div>Authenticating</div>
    )
  }
}

OAuthCallback.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  signIn: PropTypes.func.isRequired,
}

const mapDispatchToProps = {
  signIn,
}

export default compose(
  connect(null, mapDispatchToProps),
  withRouter
)(OAuthCallback)
